module.exports = __webpack_public_path__ + "img/Palau.6faf00af.svg";